import { SearchProps } from 'app/interfaces';

export class Search {
  public keywords: string;
  public matchType: string;
  public facets: any;
  public timeframe: string;
  public analysts: string;
  public countries: string;
  public vendorOutlets: string;
  public outletGroups: number[];
  public topOutletsOnly: boolean;
  public topAuthorsOnly: boolean;
  public authorFollowSelected: string;
  public outletFollowSelected: string;
  public from: Date;
  public to: Date;
  public authors: number[];
  public excludeAuthors: number[];
  public excludeOutlets: number[];
  public outlets: number[];
  public topicTypes: string;
  public topicsFilter: string;
  public topicsCollection: number;
  public topics: number[];
  public authorLabels: number[];
  public excludeAuthorLabels: number[];
  public outletLabels: number[];
  public excludeOutletLabels: number[];

  constructor({
    keywords,
    matchType,
    facets,
    timeframe,
    analysts,
    countries,
    vendorOutlets,
    outletGroups,
    topOutletsOnly,
    topAuthorsOnly,
    authorFollowSelected,
    outletFollowSelected,
    from,
    to,
    authors,
    excludeAuthors,
    excludeOutlets,
    outlets,
    topicTypes,
    topicsFilter,
    topicsCollection,
    topics,
    authorLabels,
    excludeAuthorLabels,
    outletLabels,
    excludeOutletLabels,
  }: SearchProps) {
    this.keywords = keywords || null;
    this.matchType = matchType || null;
    this.facets = facets || null;
    this.timeframe = timeframe || null;
    this.analysts = analysts || null;
    this.countries = countries || null;
    this.vendorOutlets = vendorOutlets || null;
    this.outletGroups = outletGroups || [];
    this.topOutletsOnly = topOutletsOnly || false;
    this.topAuthorsOnly = topAuthorsOnly || false;
    this.authorFollowSelected = authorFollowSelected || null;
    this.outletFollowSelected = outletFollowSelected || null;
    this.from = from || null;
    this.to = to || null;
    this.authors = authors || [];
    this.excludeAuthors = excludeAuthors || [];
    this.excludeOutlets = excludeOutlets || [];
    this.outlets = outlets || [];
    this.topicTypes = topicTypes || null;
    this.topicsFilter = topicsFilter || null;
    this.topicsCollection = topicsCollection || null;
    this.topics = topics || [];
    this.authorLabels = authorLabels || [];
    this.excludeAuthorLabels = excludeAuthorLabels || [];
    this.outletLabels = outletLabels || [];
    this.excludeOutletLabels = excludeOutletLabels || [];
  }
}
